module.exports = "https://www.gc-pro.gnp.com.mx/78ce70342d6541557ee1c4a40f8866a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-print.svg
// module id = 1834
// module chunks = 0